import React from "react";
import Layout, { useSEO } from "@/components/Layout";
import { Section, Overline, BlueRule } from "@/components/primitives";

export function Privacy() {
  useSEO({ title: "Privacy Policy | Impactful Mindset" });
  return (
    <Layout>
      <Section className="py-20">
        <Overline>Legal</Overline>
        <h1 className="font-serif-display text-4xl font-bold mt-4 text-[#111827]">Privacy Policy</h1>
        <BlueRule className="mt-6" />
        <div className="im-prose mt-8">
          <p>Impactful Mindset 101 collects only the information you choose to provide—such as your name and email when you subscribe or download a resource. We use it to send you the content you requested and occasional updates. We do not sell your data, and you can unsubscribe at any time.</p>
        </div>
      </Section>
    </Layout>
  );
}

export function Terms() {
  useSEO({ title: "Terms of Use | Impactful Mindset" });
  return (
    <Layout>
      <Section className="py-20">
        <Overline>Legal</Overline>
        <h1 className="font-serif-display text-4xl font-bold mt-4 text-[#111827]">Terms of Use</h1>
        <BlueRule className="mt-6" />
        <div className="im-prose mt-8">
          <p>By using this site you agree to use its content for personal, non-commercial purposes. All content is provided for educational purposes and does not constitute professional advice. Impactful Mindset 101 retains all rights to its original writing, principles and brand materials.</p>
        </div>
      </Section>
    </Layout>
  );
}
